import { ref } from "vue"
import type { Message as ChatMessage } from "~/stores/messages"

// Module-level singleton, matching `useMessageEditing.ts`'s pattern — only one message can be
// replied to at a time across the whole chat.
const replyingToMessage = ref<ChatMessage | null>(null)

export function useMessageReply() {
  function isReplying(): boolean {
    return replyingToMessage.value !== null
  }

  function start(message: ChatMessage) {
    replyingToMessage.value = message
  }

  function cancel() {
    replyingToMessage.value = null
  }

  return { replyingToMessage, isReplying, start, cancel }
}
